import React, { useEffect, useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import Select, { components } from "react-select";

const LabeledSelect = ({
  name,
  label,
  options = [],
  isMulti = false,
  registerOptions = {},
  addButtonLabel,
  onAddButtonClick,
  ...rest
}) => {
  const { control, formState: { errors }, setValue, getValues  } = useFormContext();
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  useEffect(() => {
    const currentValue = getValues(name);
    setValue(name, currentValue);
  }, [name, setValue, getValues]);

  const inputStyle = {
    padding: '2px',
    marginBottom: '10px',
    width: '100%',
    borderColor: errors[name] ? 'red' : 'lightgray',
    borderRadius: '5px',
    outline: 'none',
  };

  const labelStyle = {
    fontWeight: 'bold',
    display: 'block',
    marginBottom: '5px',
    color: 'black',
  };

  const isRequired = registerOptions?.required;

  const CustomMenuList = (props) => (
    <components.MenuList {...props}>
      {addButtonLabel && (
        <div
          style={{
            padding: "10px",
            borderBottom: "1px solid #eee",
            textAlign: "center",
            cursor: "pointer",
            color: "#007bff",
            fontWeight: "bold",
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            onAddButtonClick && onAddButtonClick();
            setMenuIsOpen(false);
          }}
        >
          {addButtonLabel}
        </div>
      )}
      {props.children}
    </components.MenuList>
  );

  return (
    <div className="form-group" style={{ marginBottom: '15px' }}>
      <label style={labelStyle}>
        {label}{isRequired && <span className="required-asterisk">*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        rules={registerOptions}
        render={({ field }) => (
          <Select
            {...field}
            options={options}
            isMulti={isMulti}
            placeholder="Select"
            components={{ MenuList: CustomMenuList }}
            menuIsOpen={menuIsOpen}
            onMenuOpen={() => setMenuIsOpen(true)}
            onMenuClose={() => setMenuIsOpen(false)}
            onChange={(selected) => {
              const value = isMulti
                ? selected.map((option) => option.value)
                : selected?.value;
              field.onChange(value);
            }}
            value={
              isMulti
                ? options.filter((opt) => field.value?.includes(opt.value))
                : options.find((opt) => opt.value === field.value) || null
            }
            isDisabled={rest.disabled}
            styles={{
              control: (provided) => ({
                ...provided,
                ...inputStyle,
                boxShadow: 'none',
                border: `1px solid ${inputStyle.borderColor}`,
                '&:hover': {
                  border: `1px solid ${inputStyle.borderColor}`,
                },
              }),
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
                margin: "0px",
                padding: "0px",
              }),
              option: (provided) => ({
                ...provided,
                color: 'black',
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'lightgray',
                },
              }),
              singleValue: (provided) => ({
                ...provided,
                color: 'black',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'gray',
              }),
              clearIndicator: (provided) => ({
                ...provided,
                display: 'none',
              }),
              indicatorSeparator: (provided) => ({
                ...provided,
                display: 'none',
              }),
            }}
            {...rest}
          />
        )}
      />
      {errors[name] && <span className="text-danger">{errors[name].message}</span>}
    </div>
  );
};

export default LabeledSelect;
